module.exports = __webpack_public_path__ + "static/media/031-policeman.b5eea2f8.svg";